module.exports = __webpack_public_path__ + "static/media/028-puerto-rico.7e10822e.svg";